// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @13.12.2018 15:04:21
import { RbacRole_abstract } from './../../abstract/SagaBase/RBAC/RbacRole_abstract';
export class RbacRole extends RbacRole_abstract {}
